<template>
  <v-container fluid>
    <PageHeaderSlot>
      <template slot="top-right-slot" v-if="canCreate">
        <FormButton text="createCourse" isAdd class="ml-2" :to="{ name: 'CreateOnlineCourse' }" />
      </template>
    </PageHeaderSlot>

    <Datatable
      :isLoading="tableLoading"
      :tableHeaders="tableHeaders"
      :tableData="tableData"
      :page.sync="tableFilter.page"
      :pageLimit.sync="tableFilter.limit"
      :itemTotal="tableItemTotal"
      @options-update="getCourseData()"
      actionViewRouteLink="OnlineCourseDetails"
    >
      <template v-slot:[`item.discount_price`]="{ item }">HK${{ $formatter.separator(item.discount_price) }}</template>
      <template v-slot:[`item.status`]="{ item }">
        <span v-if="item.status === 'active'" class="success--text">{{ $t('onlineCourseStatus.active') }}</span>
        <span v-else>{{ $t(`onlineCourseStatus.${item.status}`) }}</span>
      </template>
    </Datatable>
  </v-container>
</template>

<script>
import Datatable from '@/components/Datatable.vue'

export default {
  name: 'OnlineCourseList',
  components: {
    Datatable,
  },
  computed: {
    tableHeaders() {
      const vm = this
      let headers = [
        { value: 'course_category', text: vm.$t('courseCategory'), width: 200 },
        { value: 'name', text: vm.$t('courseName') },
        { value: 'chapter_count', text: vm.$t('numberOfChapter') },
        { value: 'video_count', text: vm.$t('numberOfVideo') },
        { value: 'discount_price', text: vm.$t('salesPrice') },
        { value: 'sales', text: vm.$t('salesCount') },
        { value: 'status', text: vm.$t('status') },
      ]
      if (this.$validate.allowAction('CourseDetails', this.userType)) {
        headers.push({ value: 'actionView', text: '', align: 'end' })
      }
      return headers
    },
    // permission & setting
    canCreate() {
      return this.$validate.allowAction('CreateCourse', this.userType)
    },
  },
  data: vm => ({
    userType: vm.gfGetUserType(),
    tableLoading: false,
    tableData: [],
    tableItemTotal: 0,
    tableFilter: {
      page: 1,
      limit: 10,
    },
  }),
  methods: {
    async getCourseData(regenUrl = true) {
      if (regenUrl === true) {
        this._regenerateURL()
      }

      this.tableLoading = true
      try {
        let payload = {
          filter_limit: this.tableFilter.limit,
          filter_page: this.tableFilter.page - 1,
          join_category_data: true,
          get_sales_count: true,
        }

        const { data, total } = await this.$Fetcher.GetOnlineCourses(payload)
        this.tableData = data
        this.tableItemTotal = total
      } catch (err) {
        this.$common.error(err)
        this.tableData = []
        if (this.tableFilter.page === 1) {
          this.tableItemTotal = 0
        }
      } finally {
        this.tableLoading = false
      }
    },

    _getQuery() {
      this.tableFilter.page = 1
      this.tableFilter.limit = 10

      const query = this.gfGetTableQuery({
        page: 'int',
        limit: 'int',
      })
      for (const key in this.tableFilter) {
        if (this.$validate.DataValid(query[key])) {
          this.$set(this.tableFilter, key, query[key])
        }
      }
    },
    _regenerateURL() {
      let q = {
        page: this.tableFilter.limit !== 10 || this.tableFilter.page !== 1 ? this.tableFilter.page : null,
        limit: this.tableFilter.limit !== 10 || this.tableFilter.page !== 1 ? this.tableFilter.limit : null,
      }
      const newQuery = this.$common.diffQuery(q, this.$route.query)
      if (newQuery) this.$router.replace({ query: newQuery })
    },

    async handleSiteLoaded() {
      this.$common.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> handleSiteLoaded: OnlineCourseList')
      this.userType = this.gfGetUserType()
      this._getQuery()
      this.$store.dispatch('toggleLoadingPage', false)

      await this.getCourseData(false)
    },
  },

  destroyed() {
    window.removeEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  mounted() {
    this.tableLoading = true
    this.$store.dispatch('toggleLoadingPage', true)
    window.addEventListener('onSiteLoaded', this.handleSiteLoaded)
  },

  // ------ navigation guard ------
  beforeRouteLeave(to, from, next) {
    this.$XHR.abort()
    next()
  },
}
</script>
